import { Stack, Typography } from "@mui/material";
import { AIGAccount } from "@/pages/ExpressForm/Submit/AIGAccount";
import { BankAccount } from "@/pages/ExpressForm/Submit/BankAccount";
import { CreditCardsAccount } from "@/pages/ExpressForm/Submit/CreditCardAccount";
import { DefaultAccount } from "@/pages/ExpressForm/Submit/DefaultAccount";
import { HastingsDirectAccount } from "@/pages/ExpressForm/Submit/HastingsDirectAccount";
import { InsuranceAccount } from "@/pages/ExpressForm/Submit/InsuranceAccount";
import {
  InvestmentsAccount,
  QuilterAccountSummary,
} from "@/pages/ExpressForm/Submit/InvestmentsAccount";
import { MobileAccount } from "@/pages/ExpressForm/Submit/MobileAccount";
import { MortgageAccount } from "@/pages/ExpressForm/Submit/MortgageAccount";
import { PensionAccount } from "@/pages/ExpressForm/Submit/PensionAccount";
import { SocialMediaOrEmailAccount } from "@/pages/ExpressForm/Submit/SocialMediaOrEmailAccount";
import { ServiceProvider, Account, ServiceProviderType } from "@/types";
import { useMatch, useNavigate } from "react-router-dom";
import { FieldsTableHeader, FieldsTable } from "../molecules";
import { colors } from "@/styles/constants";
import { EnergyAccount } from "@/pages/ExpressForm/Submit/EnergyAccount";
import { WaterAccount } from "@/pages/ExpressForm/Submit/WaterAccount";
import React from "react";

interface AccountSummaryI {
  sp: ServiceProvider;
  account: Partial<Account>;
}
export const ExpressAccountSummary: React.FC<AccountSummaryI> = ({ sp, account }) => {
  const match = useMatch("/express/:slug/*");
  const navigate = useNavigate();
  const onEditAccount = React.useCallback(() => {
    navigate(`${match?.pathnameBase}/account`);
  }, [navigate, match]);
  const accountSectionTitle =
    sp.serviceProviderType === ServiceProviderType.Insurance
      ? "Policy details for the person who died"
      : "Account details for the person who died";

  const accountComponents: { [key: string]: React.FC<any> } = {
    aig: AIGAccount,
    "hastings-direct": HastingsDirectAccount,
    quilter: QuilterAccountSummary,
    [ServiceProviderType.Banking]: BankAccount,
    [ServiceProviderType.BuildingSociety]: BankAccount,
    [ServiceProviderType.CreditCards]: CreditCardsAccount,
    [ServiceProviderType.Energy]: EnergyAccount,
    [ServiceProviderType.Insurance]: InsuranceAccount,
    [ServiceProviderType.Investments]: InvestmentsAccount,
    [ServiceProviderType.Mobile]: MobileAccount,
    [ServiceProviderType.Mortgage]: MortgageAccount,
    [ServiceProviderType.Pension]: PensionAccount,
    [ServiceProviderType.SocialMedia]: SocialMediaOrEmailAccount,
    [ServiceProviderType.Email]: SocialMediaOrEmailAccount,
    [ServiceProviderType.Water]: WaterAccount,
    default: DefaultAccount,
  };

  const getAccountComponent = () => {
    if (sp.customForm && accountComponents[sp.customForm]) return accountComponents[sp.customForm];
    if (sp.serviceProviderType && accountComponents[sp.serviceProviderType])
      return accountComponents[sp.serviceProviderType];
    return accountComponents.default;
  };
  const AccountComponent = getAccountComponent();

  return (
    <>
      {!account ? (
        <Stack rowGap={2}>
          <FieldsTableHeader title={accountSectionTitle} onEdit={onEditAccount} />
          <Typography variant="body1" color={colors.fadedText}>
            Not completed yet
          </Typography>
        </Stack>
      ) : (
        <FieldsTable
          header={<FieldsTableHeader title={accountSectionTitle} onEdit={onEditAccount} />}
        >
          <AccountComponent
            account={account}
            serviceProviderType={sp.serviceProviderType}
            serviceProvider={sp}
          />
        </FieldsTable>
      )}
    </>
  );
};
